import React from 'react';
import Swiper from 'react-id-swiper';
import PreLoginSessionCheck from './PreLoginSessionCheck.js';
import GoogleAnalytics from '../../../util/Ga.js';

// ES6 classNameNameNameNameNameName-style
class Recognised extends PreLoginSessionCheck {

	constructor () {
		super()
		this.goNext = this.goNext.bind(this)
    	this.goPrev = this.goPrev.bind(this)
	}

	goNext() {
	    if (this.swiper) this.swiper.slideNext()
	}
	 
	goPrev() {
	    if (this.swiper) this.swiper.slidePrev()
	}


  render() {

  	const params = {
		slidesPerView: 3,
	 	spaceBetween: 30,
	 	loop: true,
	 	navigation: {
	        nextEl: '.swiper-button-next',
	        prevEl: '.swiper-button-prev',
	        nextButtonCustomizedClass:'.swp-next',
	    	prevButtonCustomizedClass:'.swp-prev'	
	    },
	    breakpoints: {
		    480: {
		      slidesPerView: 1,
		      spaceBetween: 20
		    },
		    640: {
		      slidesPerView: 2,
		      spaceBetween: 30
		    },
		    768: {
		      slidesPerView: 2,
		      spaceBetween: 30
		    }
		}
    }

  	return(
		<section className="mtb whyhm prod-detl who-we-btm">
			<div className="">
				<div className="container">
					<h2 className="mb-30 rec-heading">Our work has been recognised by</h2>
					<div className="row"> 
					<Swiper className="our-learning recogzize-slider outer-padding" breakpoints={params.breakpoints}  loop={params.loop} slidesPerView={params.slidesPerView} spaceBetween={params.spaceBetween}  ref={node => {if(node) this.swiper = node.swiper} }>						

								<div className="swiper-slide">
									<a data-ga="Who we are - Our work has been recognised by - Still eating our lunch" href="https://www.nytimes.com/2005/09/16/opinion/still-eating-our-lunch.html" target="_blank" className="learn-box recognise-box">
										<div className="our-img">
											<img src="../img/recg2.jpg" alt="Still eating our lunch article published by The New York Times"/>
										</div>
										<div className="our-text">
											<p>Published by: <span>The New York Times</span></p>
											<h3>Still Eating Our Lunch</h3>
										</div>
									</a>
								</div>
								<div className="swiper-slide">
									<a data-ga="Who we are - Our work has been recognised by - How maths can be great fun" href="http://news.bbc.co.uk/2/hi/south_asia/5203440.stm" target="_blank" className="learn-box recognise-box">
										<div className="our-img">
											<img src="../img/recg5.jpg" alt="How maths can be great fun article published by BBC News"/>
										</div>
										<div className="our-text">
											<p>Published by: <span>BBC News</span></p>
											<h3>How maths can be great fun</h3>
										</div>
									</a>
								</div>
								<div className="swiper-slide">
									<a data-ga="Who we are - Our work has been recognised by - Lets talk about figures" href="https://www.economist.com/node/10880471" target="_blank" className="learn-box recognise-box">
										<div className="our-img">
											<img src="../img/recg1.jpg" alt="Lets talk about figures article published by The Economist"/>
										</div>
										<div className="our-text">
											<p>Published by: <span>The Economist</span></p>
											<h3>Let's talk about figures</h3>
										</div>
									</a>
								</div>
								<div className="swiper-slide">
									<a data-ga="Who we are - Our work has been recognised by - De-mystifying maths" href="https://heymath.com/common/spotlight/2008/timesofindia_may08.pdf" target="_blank" className="learn-box recognise-box">
										<div className="our-img">
											<img src="../img/recg3.jpg" alt="De-Mystifying Math article published by Education Times"/>
										</div>
										<div className="our-text">
											<p>Published by: <span>Education Times</span></p>
											<h3>De-mystifying Math</h3>
										</div>
									</a>
								</div>
								<div className="swiper-slide">
									<a data-ga="Who we are - Our work has been recognised by - Hey, math can be great fun" href="https://heymath.com/common/spotlight/2007/outlook.jpg" target="_blank" className="learn-box recognise-box">
										<div className="our-img">
											<img src="../img/recg4.jpg" alt="Hey, Math can be great fun published by Outlook Business"/>
										</div>
										<div className="our-text">
											<p>Published by: <span>Outlook Business</span></p>
											<h3>Hey, Math can be great fun</h3>
										</div>
									</a>
								</div>

						</Swiper> 
						<div className="slider-btns">
			        		<div className="swiper-button-prev swp-prev btn-p-blk" onClick={this.goPrev}></div>
			        		<div className="swiper-button-next swp-next btn-n-blk"  onClick={this.goNext}></div>
		        		</div>
					</div> 
				</div>
			</div>
		</section>
  		);
  	}
}

export default Recognised; 


// WEBPACK FOOTER //
// ./src/prelogin/src/components/Recognised.js